import APIS from '../../module/apis'
import { axios as $http } from 'cm'
function getChannelId() {
  let searchParamsList = new URLSearchParams(window.location.search)
  let result = 522
  if (searchParamsList.has('lx_channel_id')) {
    result = searchParamsList.get('lx_channel_id')
  }
  return result
}
export async function updatePlayTime(id, cb) {
  const url =
    `${APIS.periodClock}` +
    `?lessonId=${
      window.baseInfo.lesson_id
    }&keshiId=${id}&keshiType=6&channelId=${getChannelId()}`
  await $http.get(url)
  cb && cb()
}
export function appToWeapp(el) {
  if (el.classList.contains('lock')) return
  updatePlayTime(el.dataset.id, function() {
    el.classList.add('lock')
  })
}
export function wxToWeapp(el) {
  const item = el.querySelector('template').content.querySelector('div')
  appToWeapp(item)
}



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/clock/weappEvent.js